import { HTMLAttributes } from "react";

export default function RadixUI(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.0399 48C18.9662 48 15.0593 46.3817 12.1788 43.5012C9.29821 40.6206 7.67993 36.7137 7.67993 32.64C7.67993 28.5663 9.29821 24.6594 12.1788 21.7788C15.0593 18.8983 18.9662 17.28 23.0399 17.28V48ZM23.0399 0V15.36H7.67993V0H23.0399ZM32.6399 15.36C30.6031 15.36 28.6496 14.5509 27.2094 13.1106C25.7691 11.6703 24.9599 9.71686 24.9599 7.68C24.9599 5.64314 25.7691 3.6897 27.2094 2.24942C28.6496 0.809141 30.6031 0 32.6399 0C34.6768 0 36.6302 0.809141 38.0705 2.24942C39.5108 3.6897 40.3199 5.64314 40.3199 7.68C40.3199 9.71686 39.5108 11.6703 38.0705 13.1106C36.6302 14.5509 34.6768 15.36 32.6399 15.36Z"
        fill="black"
      />
    </svg>
  )
}
